import React from "react";
import paint from "../../assets/paint.png";
import ceramic from "../../assets/ceramic.png";
import graph from "../../assets/graph.png";
import texture from "../../assets/texture.png";
import { Link } from "react-router-dom";

const OurServices = ({id}) => {
  return (
    <>
      <div
        id={id}
        className="text-center leading-normal gap-6 grid my-9 self-stretch text-white"
        style={{ fontFamily: "Barlow Condensed" }}
      >
        <h2
          className="text-center text-black mb-4 text-5xl col-span-full"
          style={{ fontFamily: "Ballega" }}
        >
          Our Services
        </h2>

        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-9 sm:mb-20 px-6 sm:px-16">
          <Link
            to="/ppf"
            className="flex flex-col justify-center items-center bg-center bg-no-repeat bg-cover p-8"
            style={{
              backgroundImage: `url(${texture})`,
              backgroundColor: "black",
            }}
          >
            <h4 className="text-3xl" style={{ fontFamily: "Ballega" }}>
              Paint Protection{" "}
              <span>
                <br />
                Film
              </span>
            </h4>
            <p className="mb-6">
              PPF provides a layer of protection that can help to prevent damage
              to your car's paint, keeping it looking new for longer. One of the
              unique features of a high-performing PPF is its ability to
              self-heal.
            </p>
            <p to="/ppf" className="bg-black p-2 font-bold tracking-wide">
              Know More
            </p>
            <img src={paint} alt="paint" className="mt-9" />
          </Link>

          <Link to="/ceramic" className="bg-red-600 flex flex-col justify-center items-center p-8">
            <h4 className="text-3xl" style={{ fontFamily: "Ballega" }}>
              Ceramic
            </h4>
            <p className="mb-6">
              Industry-grade ceramic coating is a chemical polymer solution that
              is applied to the exterior of a vehicle to protect it from
              external paint damage. Typically applied by hand, it blends with
              the paint of your car and creates an additional hydrophobic layer
              of protection.
            </p>
            <p
              to="/ceramic"
              className="bg-black p-2 font-bold tracking-wide"
            >
              Know More
            </p>
            <img src={ceramic} alt="ceramic" className="mt-9" />
          </Link>

          <Link to="/graphene" className="bg-yellow-500 flex flex-col sm:col-span-full lg:col-span-1 justify-center items-center p-8">
            <h4 className="text-3xl" style={{ fontFamily: "Ballega" }}>
              Graphine Coating
            </h4>
            <p className="mb-6">
              Graphene is a single layer of carbon atoms in a hexagonal lattice.
              Its structure provides extraordinary strength, thermal and
              electrical conductivity, and flexibility. Used in coatings,
              graphene enhances vehicle protection.
            </p>
            <p
              to="/graphene"
              className="bg-black p-2 font-bold tracking-wide"
            >
              Know More
            </p>
            <img src={graph} alt="graph" className="mt-9" />
          </Link>
        </section>
      </div>
    </>
  );
};

export default OurServices;
